import api from '@/lib/api'

const state = () => ({
  paymentSecret: null,
  paymentMethods: [],
})

const getters = {
  paymentSecret:  state => state.paymentSecret,
  paymentMethods: state => state.paymentMethods,
}

const actions = {
  async loadPaymentSecret({commit}) {
    const result = await api.get('/payment_methods/setup')
    if (result.ok) {
      commit('SET_PAYMENT_SECRET', await result.json())
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadPaymentMethods({ commit }) {
    const result = await api.get('/payment_methods')
    if (result.ok) {
      commit('SET_PAYMENT_METHODS', await result.json())
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async setDefaultMethod({ dispatch }, { setup_intent, payment_method, refill }) {
    await api.put('/payment_methods/default', { setup_intent, payment_method, refill })
    dispatch('loadPaymentMethods')
    dispatch('auth/loadMe', {}, { root: true })
  },

  async deleteMethod({ dispatch }, { payment_method }) {
    await api.delete(`/payment_methods/${ payment_method }`)
    dispatch('loadPaymentMethods')
    dispatch('auth/loadMe', {}, { root: true })
  },
}

const mutations = { 
  SET_PAYMENT_SECRET: (state, paymentSecret) => state.paymentSecret = paymentSecret,
  SET_PAYMENT_METHODS: (state, paymentMethods) =>  state.paymentMethods = paymentMethods,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}